var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import Button from "./Button";
var saveDraftScript = function (contnet) {
    console.log(contnet);
    console.log("draft save!");
};
var publishHandler = function (contnet) {
    console.log(contnet);
    console.log("article publish!");
};
var RightNavigation = function () {
    var onStoreDraft = function (callback) {
        var content = localStorage.getItem("content");
        if (content) {
            callback(content);
        }
    };
    var onPublish = function (callback) {
        var content = localStorage.getItem("content");
        if (content) {
            callback(content);
        }
    };
    return (_jsxs("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: end;\n        justify-content: flex-end;\n        margin-right: 15px;\n        float: right;\n        width: auto;\n        gap: 15px;\n      "], ["\n        position: relative;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: end;\n        justify-content: flex-end;\n        margin-right: 15px;\n        float: right;\n        width: auto;\n        gap: 15px;\n      "]))) }, { children: [_jsx(Button, { text: "\u6E96\u5099\u767C\u4F48", onMouseDown: function () {
                    onPublish(publishHandler);
                } }), _jsx(Button, { text: "\u5132\u5B58\u8349\u7A3F", className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          background: transparent;\n          color: rgb(20, 20, 19);\n          border: 1px solid rgb(83, 81, 80);\n        "], ["\n          background: transparent;\n          color: rgb(20, 20, 19);\n          border: 1px solid rgb(83, 81, 80);\n        "]))), onMouseDown: function () {
                    onStoreDraft(saveDraftScript);
                } }), _jsx("div", { children: "..." }), _jsx("span", __assign({ className: cx("material-icons", css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            font-size: 30px;\n            vertical-align: text-bottom;\n            cursor: pointer;\n          "], ["\n            font-size: 30px;\n            vertical-align: text-bottom;\n            cursor: pointer;\n          "])))) }, { children: "account_circle" }))] })));
};
export default RightNavigation;
var templateObject_1, templateObject_2, templateObject_3;
